import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

interface DateObject {
    year: number;
    month: number;
    day: number;
}

@Pipe({
    name: 'formatDate',
    standalone: false
})
export class FormatDate implements PipeTransform {
    private readonly monthOffset: number = 1;
    transform(value: string | Date | DateObject | null | undefined): string | null {
        if (value !== '' && value !== null && value !== undefined) {
            switch (typeof value) {
                case 'object': {
                    if (value instanceof Date) {
                       return moment(value).format('MM/DD/YYYY');
                    }
                    const val: DateObject = {
                        year: value.year,
                        month: value.month - this.monthOffset,
                        day: value.day
                    };
                    return moment(val).format('MM/DD/YYYY');
                }
                case 'string':
                    return moment(value).format('MM/DD/YYYY');
                default:
                    return null;
            }
        } else {
            return '';
        }

    }
}
